import React from "react";

import { PageHeader, Popconfirm, Button, Typography, Space } from "antd";
import { DeleteOutlined, DownloadOutlined, PaperClipOutlined } from "@ant-design/icons";

import UploadButton from "../../../../../components/upload/button";

import PropTypes from "prop-types";

const propTypes = {
    attachment: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    isLoading: PropTypes.bool,
    allowRemove: PropTypes.bool,
    onDownload: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};

const defaultProps = {
    allowRemove: true,
    isLoading: false,
    attachment: null,
};

const { Text } = Typography;

const AttachmentHeader = (props) => {
    const { attachment, onDownload, onUpload, onRemove, isLoading, allowRemove } = props;

    if (attachment && attachment.name) {
        return (
            <PageHeader
                ghost={false}
                title={
                    <>
                        <PaperClipOutlined /> Attachment
                    </>
                }
                extra={[
                    <Space key="buttons">
                        {allowRemove && (
                            <Popconfirm
                                title="Are you sure?"
                                onConfirm={onRemove}
                                okText="Yes"
                                cancelText="No"
                                disabled={isLoading}
                            >
                                <Button
                                    key="delete"
                                    style={{ margin: 0 }}
                                    icon={<DeleteOutlined />}
                                    size="small"
                                    disabled={isLoading}
                                    danger
                                />
                            </Popconfirm>
                        )}
                        <Button
                            key="download"
                            style={{ margin: 0 }}
                            icon={<DownloadOutlined />}
                            size="small"
                            disabled={isLoading}
                            onClick={onDownload}
                        />
                    </Space>,
                ]}
            >
                <Text type="secondary">
                    <PaperClipOutlined /> {attachment.name}
                </Text>
            </PageHeader>
        );
    }

    return (
        <PageHeader
            ghost={false}
            title={
                <>
                    <PaperClipOutlined /> Attachment
                </>
            }
            backIcon={<PaperClipOutlined />}
            extra={[
                <Space key="buttons">
                    <UploadButton key="upload" buttonLabel="Upload Invoice" modalLabel="Invoice" onUpload={onUpload} />
                </Space>,
            ]}
        />
    );
};

AttachmentHeader.propTypes = propTypes;
AttachmentHeader.defaultProps = defaultProps;

export default AttachmentHeader;
